export const LAYOUT_GRID_VIEW = 0;
export const LAYOUT_LIST_VIEW = 1;
export const LAYOUT_FF_PAGE_VIEW = 2;
